define((require) => {
    "use strict";

    const Promise = require("es6-promise");

    const polyfillPromiseFunction = () => {
        if (!window.Promise) {
            window.Promise = Promise;
        }
    };

    polyfillPromiseFunction();
});



// WEBPACK FOOTER //
// ./src/shared/util/PromisePolyfill.js